const LicenseeLineColumns = [
    { headerName: "Charge Type", field: "chargeType" },
    { headerName: "Brand", field: "brand" },
    { headerName: "Account", field: "account" },
    { headerName: "Amount", field: "amount" },
    { headerName: "Batch Ref.", field: "batchRef" },
    { headerName: "Charge Period", field: "chargePeriod" }
];

export default LicenseeLineColumns;